import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchOrgTermsOfUse,
  fetchOrgTermsOfUseStatus,
  fetchTrainerTermsOfUse,
  fetchMarketplaceItemTermsOfUse,
  fetchMarketplacePurchaseTermsOfUse,
} from '../api/termsOfUse.api';

export const termsOfUseQueryKeys = createQueryKeys('termsOfUse', {
  fetchOrgTermsOfUse: ({ organizationId }: { organizationId: string }) => ({
    queryFn: () => fetchOrgTermsOfUse({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchOrgTermsOfUseStatus: ({
    organizationId,
  }: {
    organizationId: string;
  }) => ({
    queryFn: () => fetchOrgTermsOfUseStatus({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchTrainerTermsOfUse: ({ organizationId }: { organizationId: string }) => ({
    queryFn: () => fetchTrainerTermsOfUse({ organizationId }),
    queryKey: ['trainers', organizationId],
  }),
  fetchMarketplaceItemTermsOfUse: ({
    marketplaceId,
  }: {
    marketplaceId: string;
  }) => ({
    queryFn: () => fetchMarketplaceItemTermsOfUse({ marketplaceId }),
    queryKey: [marketplaceId],
  }),
  fetchMarketplacePurchaseTermsOfUse: ({
    purchaseId,
  }: {
    purchaseId: string;
  }) => ({
    queryFn: () => fetchMarketplacePurchaseTermsOfUse({ purchaseId }),
    queryKey: ['purchase', purchaseId],
  }),
});
